export const passwordRegex: RegExp =
  /^(?=[^A-Z]*[A-Z])(?=[^a-z]*[a-z])(?=\D*\d).{8,}$/

export const sessionLSKey = 'session'

export const USER_ROLES = {
  MASTER: 'Master',
  ADMIN: 'Admin',
  COMPLIANCE_OFFICER: 'Compliance Officer',
}

export const USER_ROLES_WITH_COMPANY = [
  USER_ROLES.ADMIN,
  USER_ROLES.COMPLIANCE_OFFICER,
]
